// src/services/authService.js
import api from "@/services/api";
import authHeader from "./authHeader";

export const authService = {
  async signIn(authData) {
    return await api.post("/login", authData);
  },

  async signUp(authData) {
    return await api.post("/register", authData);
  },

  async logout() {
    return await api.post("/logout", { }, { headers: authHeader() });
  },
};

export default authService;
